/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_FluxInputs */

const ja_home_brands_flux = /** @type {(inputs: Home_Brands_FluxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux`)
};

const en_home_brands_flux = /** @type {(inputs: Home_Brands_FluxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux`)
};

/**
* | output |
* | --- |
* | "Flux" |
*
* @param {Home_Brands_FluxInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_flux = /** @type {((inputs?: Home_Brands_FluxInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_FluxInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_flux(inputs)
	return en_home_brands_flux(inputs)
});